const HorizontalScrollLogoUX = () => {
    if ($('.horizontal-scrolling-images').length <= 0) return null;

    $('.horizontal-scrolling-images').each(function() {
        const $parent = $('.horizontal-scrolling-images');
        const $slider = $parent.find('.horizontal-scrolling-list');
        
        const $arrowContainer = $parent.next('.horizontal-scrolling-buttons');
        const $prevArrow = $arrowContainer.find('.logo-slider-arrow.prev');
        const $nextArrow = $arrowContainer.find('.logo-slider-arrow.next');

        $slider.slick({
            slidesToScroll: 1,
            slidesToShow: parseInt($slider.data('desktop-col')),
            infinite: true,
            dots: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        // autoplay: true,
                        // autoplaySpeed: 4000,
                        arrows: true,
                        prevArrow: $prevArrow,
                        nextArrow: $nextArrow
                    }
                }
            ]
        })
    })
}

export default HorizontalScrollLogoUX